// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-networks[data-v-678f0a26]{padding:15px;display:flex;align-items:center}.social-networks__item[data-v-678f0a26]{flex:1}.social-networks__item:hover .social-networks__icon[data-v-678f0a26]{box-shadow:0 0 30px 10px rgba(0,159,227,.2)}.social-networks__icon[data-v-678f0a26]{width:50px;transition:.4s ease-in-out}", ""]);
// Exports
module.exports = exports;
